//CHECKED
import "firebase/firestore";
import React, { PropsWithChildren, useEffect, useState } from "react";
import { filterStores } from "../functions/filterStores";
import { getAirbnb } from "../functions/getAirbnb";
import { getGooglePlace } from "../functions/getGooglePlace";
import { sortStores } from "../functions/sortStores";
import { IAppContextState } from "../interfaces/IAppContextState";
import { Store } from "../interfaces/IStore";

declare global {
  interface Window {
    data?: {
      [key: string]: any;
    };
  }
}
export const distanceTable: { [key: string]: number } = {
  21: 1000,
  20: 1000,
  19: 2000,
  18: 2000,
  17: 6000,
  16: 8000,
  15: 10000,
  14: 13000,
  13: 16000,
  12: 18000,
  11: 20000,
  10: 25000,
  9: 50000,
  8: 4622324.614,
  7: 9244649.227,
  6: 18489298.45,
  5: 36978596.91,
  4: 73957193.82,
  3: 147914387.6,
  2: 295828775.3,
  1: 591657550.5,
};

const initialState: IAppContextState = {
  apiKey: "AIzaSyDu38iTBz3xKFM8-xnluvYvzuPNFR6fylc",
  stores: [],
  setStores: (stores: Store[]) => {},
  searchResultCoords: {
    lat: 45.5017,
    lng: -73.5673,
  },
  setSearchResultCoords: () => {},
  selectedStore: undefined,
  setSelectedStore: () => {},
  showResults: false,
  setShowResults: () => {},
  globalIndividualStore: undefined,
  setGlobalIndividualStore: (store: Store | undefined) => {},
  isSelectFromMap: false,
  setIsSelectFromMap: (isSelectFromMap: boolean) => {},
  productFiltersGlobal: [],
  setProductFiltersGlobal: (productFiltersGlobal: string[]) => {},
  businessFiltersGlobal: undefined,
  setBusinessFiltersGlobal: (businessFiltersGlobal: string | undefined) => {},
  zoomLevel: 15,
  setZoomLevel: (zoomLevel: number) => {},
  searchRange: distanceTable["5"],
  setSearchRange: (searchRange: number) => {},
  isShowSideMenu: false,
  setIsShowSideMenu: (toggleSideMenu: boolean) => {},
  googleData: undefined,
  airbnbData: undefined,
  showProductFilters: false,
  setShowProductFilters: (newValue: boolean) => {},
  showBusinessFilters: false,
  setShowBusinessFilters: (newValue: boolean) => {},
};

export const AppContext = React.createContext<IAppContextState>(initialState);

export const AppContextProvider = (props: PropsWithChildren<any>) => {
  const [searchResultCoords, setSearchResultCoords] = useState({
    lat: 45.5017,
    lng: -73.5673,
  });
  const [stores, setStores] = useState<Store[]>(
    sortStores(props.coords, props.stores)
  );
  const [productFiltersGlobal, setProductFiltersGlobal] = useState<string[]>(
    []
  );

  const [businessFiltersGlobal, setBusinessFiltersGlobal] = useState<
    string | undefined
  >();

  useEffect(() => {
    setStores(sortStores(props.coords, props.stores));
  }, [props.stores, props.coords]);

  useEffect(() => {
    props.setStores(
      filterStores(props.allStores, businessFiltersGlobal, productFiltersGlobal)
    );
  }, [productFiltersGlobal, businessFiltersGlobal]);

  const [selectedStore, setSelectedStore] = useState<string | undefined>();

  const [showResults, setShowResults] = useState<boolean>(true);

  const [isMarkerClicked, setIsMarkerClicked] = useState(false);

  const [zoomLevel, setZoomLevel] = useState<number>(5);
  const [searchRange, setSearchRange] = useState<number>(distanceTable["5"]);

  const [globalIndividualStore, setGlobalIndividualStore] = useState<
    Store | undefined
  >();

  const [isSelectFromMap, setIsSelectFromMap] = useState<boolean>(false);

  const [isShowSideMenu, setIsShowSideMenu] = useState(false);

  const [googleData, setGoogleData] = useState<any>();
  const [airbnbData, setAirbnbData] = useState<any>();

  const [showProductFilters, setShowProductFilters] = useState(false);

  const [showBusinessFilters, setShowBusinessFilters] = useState(false);

  useEffect(() => {
    globalIndividualStore?.google_id &&
      getGooglePlace({ id: globalIndividualStore.google_id }).then(
        setGoogleData
      );
    globalIndividualStore?.airbnb_id &&
      getAirbnb({ id: globalIndividualStore.airbnb_id.toString() }).then(
        setAirbnbData
      );
  }, [globalIndividualStore]);

  return (
    <AppContext.Provider
      value={{
        apiKey: initialState.apiKey,
        stores,
        setStores,
        searchResultCoords,
        setSearchResultCoords,
        selectedStore,
        setSelectedStore,
        showResults,
        setShowResults,
        //isMarkerClicked,
        //setIsMarkerClicked,
        zoomLevel,
        setZoomLevel,
        searchRange,
        setSearchRange,
        globalIndividualStore,
        setGlobalIndividualStore,
        isSelectFromMap,
        setIsSelectFromMap,
        productFiltersGlobal,
        setProductFiltersGlobal,
        businessFiltersGlobal,
        setBusinessFiltersGlobal,
        isShowSideMenu,
        setIsShowSideMenu,
        googleData,
        airbnbData,
        showProductFilters,
        setShowProductFilters,
        showBusinessFilters,
        setShowBusinessFilters,
      }}>
      {props.children}
    </AppContext.Provider>
  );
};
